module.exports = __webpack_public_path__ + "img/banner_text_4.921b8cb9.png";